// Application constants
export const APP_CONFIG = {
  NAME: "NotionPress",
  VERSION: "1.0.0",
  RISK_LEVEL: "",
  RISK_ID: "ACM-2024-001",
};

export const VALIDATION_RULES = {
  EMAIL_REGEX: /^\S+@\S+\.\S+$/,
  MIN_PASSWORD_LENGTH: 6,
  MAX_PASSWORD_LENGTH: 128,
};

export const API_ENDPOINTS = {
  LOGIN: "/api/auth/login",
  LOGOUT: "/api/auth/logout",
  REFRESH: "/api/auth/refresh",
};

export const ROUTES = {
  LOGIN: "/login",
  DASHBOARD: "/dashboard",
  QUERIES: "/queries",
  INVOICES: "/invoices",
  BILLS: "/bills",
};
